import qna from "../assets/images/QnA.png";
import moonWaltz from "../assets/images/Moon Waltz.png";
import luckyTower from "../assets/images/LuckyTower.png";
import escapingHell from "../assets/images/EscapingHell_full.png";
import chromaticAberration from "../assets/images/ChromaticAberration.png";
// import chromaticAberration_card from "../assets/images/ChromaticAberration_card.png";
import splatter from "../assets/images/Splatter.png";
import theLastStand from "../assets/images/TheLastStand.png";
import clothSim from "../assets/images/ClothSimCard.png";

import "../assets/styles/Project.scss";

interface SingleProjectProps {
  title: string;
  link: string;
  img: string;
  description: string;
}
function SingleProject({ title, link, img, description }: SingleProjectProps) {
  return (
    <div className="project">
      <a href={link} target="_blank" rel="noreferrer">
        <img
          src={img}
          className="zoom"
          alt="thumbnail"
          width="100%"
          style={{ aspectRatio: "3/2" }}
        />
      </a>
      <a href={link} target="_blank" rel="noreferrer">
        <h2>{title}</h2>
      </a>
      <p>{description}</p>
    </div>
  );
}

function Project() {
  return (
    <div className="projects-container" id="projects">
      <h1>Projects</h1>
      <div className="projects-grid">
        <SingleProject
          title="Q&A Template"
          link="https://developers.snap.com/lens-studio/4.55.1/references/templates/audio/q&a-template-guide"
          img={qna}
          description="A Template for Snapchat Filters, where the developer can pass a context text to an AI, which answers users' questions"
        />
        <SingleProject
          title="Lucky Tower"
          link="https://store.steampowered.com/app/1700270/Lucky_Tower_Ultimate/"
          img={luckyTower}
          description="A unity Roguelike with puzzles, monsters and lots of creative ways to die."
        />
        <SingleProject
          title="The Last Stand"
          link="https://sarahwerum.itch.io/the-last-stand"
          img={theLastStand}
          description="A unity game built for the International Game Jam with Students from Universities all over Europe. Fight AI Slop monstrosities as a cat artist with a giant paintbrush."
        />
        <SingleProject
          title="Moon Waltz"
          link="https://poki.com/en/g/moon-waltz"
          img={moonWaltz}
          description="A flash game, where you play a werewolf trying to buy some cigarettes"
        />
        <SingleProject
          title="Splatter"
          link="https://sarahwerum.itch.io/splatter"
          img={splatter}
          description="A unity game, where you throw paint at a canvas to create art"
        />
        <SingleProject
          title="2D Cloth Simulation"
          link="https://github.com/swerum/Cloth-Simulation"
          img={clothSim}
          description="A 2D Cloth Simulation using Mass Spring Dampers built in Godot"
        />
        <SingleProject
          title="Chromatic Aberration"
          link="https://sarahwerum.itch.io/chromatic-aberration"
          img={chromaticAberration}
          description="A puzzle game, where you build the labyrinth for the mouse to get to the cheese"
        />
        <SingleProject
          title="Escaping Hell"
          link="https://store.steampowered.com/app/1378820/Escaping_Hell/"
          img={escapingHell}
          description="A narrative RPG inspired by early Zelda games built in Game Maker"
        />
      </div>
    </div>
  );
}

export default Project;
